import { render } from "./dashboardCanViewLoanCellTemplate.vue?vue&type=template&id=be641a94"
import script from "./dashboardCanViewLoanCellTemplate.vue?vue&type=script&lang=js"
export * from "./dashboardCanViewLoanCellTemplate.vue?vue&type=script&lang=js"

import "./dashboardCanViewLoanCellTemplate.vue?vue&type=style&index=0&id=be641a94&lang=css"

import exportComponent from "D:\\a\\1\\s\\eNotary.SPA\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__